/**
 * 项目详细信息实体
 */

import { useState, useEffect } from 'react';
import {
    Modal,
    Input,
    Row,
    Col,
    message,
    Select,
    InputNumber,
    DatePicker,
} from 'antd';
import $ from 'jquery';
import {
    AddRequestHeaders,
    UjoinParams,
    rff,
    currentDate,
} from '../../incs/FunHelper';
import CNF from '../../incs/Config';


/** 
* 日期样式
*/
import dayjs from 'dayjs';

const Option = Select.Option;
const { TextArea } = Input;


const Entity = (props) => {
    const [messageApi, contextHolder] = message.useMessage();

    const [loading, setLoading] = useState(false);
    const [rank, setRank] = useState(1);
    const [contractDate, setContractDate] = useState(currentDate);
    const [contractNumber, setContractNumber] = useState('');
    const [contractAmount, setContractAmount] = useState(0);
    const [projectDDList, setProjectDDList] = useState('');
    const [projectULID, setProjectULID] = useState('');
    const [description, setDescription] = useState('');

    const cancel = () => {
        props.setOpen(false);
        setLoading(false);
        setRank(1);
        setContractDate(currentDate);
        setContractNumber('');
        setContractAmount(0);
        setProjectULID('');
        setDescription('');
    };

    useEffect(() => {
        // 修改初始化
        if (props.record) {
            setRank(props.record.rank);
            setContractDate(props.record.contract_date ? props.record.contract_date : currentDate);
            setContractNumber(props.record.contract_number);
            setContractAmount(props.record.contract_amount);
            setProjectULID(props.record.project_ulid);
        }
    }, [props.record]);

    useEffect(() => {
        const params = {
            'rss': 'list',
            'rank': 1,
            'page_size': 65535,
            'current_index': 1
        };
        $.ajax({
            url: `${CNF.api}project/bases${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            crossDomain: true,
            type: 'GET', success: function (data) {
                if (data.res === 0) {
                    setProjectDDList(data.dat);
                }
            }
        })
    }, []);


    const ok = () => {
        //  参数校验
        setLoading(true);
        $.ajax({
            url: `${CNF.api}project/details/${props.record.key}`,
            headers: AddRequestHeaders(),
            type: 'PUT',
            dataType: 'JSON',
            data: JSON.stringify({
                'rank': rank,
                'contract_date': contractDate,
                'contract_number': contractNumber,
                'contract_amount': contractAmount,
                'project_ulid': projectULID,
                'description': description,
            }),
        }).done(function (data) {
            if (data.res === 0) {
                messageApi.success(data.msg, CNF.messageDuration);
                setTimeout(function () {
                    cancel();
                    props.isRefresh();
                }, CNF.messageDuration * 1000);
            } else {
                setLoading(false);
                messageApi.error(data.msg, CNF.messageDuration);
            }
        }).fail(function (data) {
            setLoading(false);
            messageApi.error(data.responseJSON.detail, CNF.messageDuration);
        });
    };



    return (
        <>
            {contextHolder}
            <Modal
                width={600}
                title={props.record ? props.record.name : ''}
                open={props.open}
                onOk={ok}
                onCancel={cancel}
                keyboard={true}
                okText='确认'
                cancelText='取消'
                okButtonProps={{ disabled: loading }}
            >
                <Row>
                    <Col span={12}>{rff}项目层级</Col>
                    <Col span={11} offset={1}>{rff}签订日期</Col>
                    <Col span={12}>
                        <Select
                            style={{ width: '100%' }}
                            value={rank}
                            onChange={(value) => setRank(value)}
                            disabled={loading}
                        >
                            <Option value={1}>主项目</Option>
                            <Option value={2}>子项目</Option>
                        </Select>
                    </Col>
                    <Col span={11} offset={1}>
                        <DatePicker
                            placeholder='请选择日期'
                            style={{ width: '100%' }}
                            value={dayjs(contractDate, 'YYYY-MM-DD')}
                            onChange={(_, dateString) => setContractDate(dateString)}
                            disabled={loading}
                        />
                    </Col>
                </Row>
                {
                    rank > 1 ? <Row style={{ marginTop: CNF.rowMarginTop, }}>
                        <Col span={24}>父级项目</Col>
                        <Col span={24}>
                            <Select
                                value={projectULID}
                                style={{ width: '100%' }}
                                onChange={(value) => setProjectULID(value)}
                                showSearch
                                filterOption={(input, option) => option.props.children.indexOf(input) >= 0}
                                disabled={loading}
                            >
                                <Option value=''>主项目</Option>
                                {
                                    projectDDList.length && projectDDList.map((item, index) => {
                                        return <Option key={index} value={item['key']}>{item['name']}</Option>
                                    })
                                }
                            </Select>
                        </Col>
                    </Row> : ''
                }
                <Row style={{ marginTop: CNF.rowMarginTop, }}>
                    <Col span={12}>合同编号</Col>
                    <Col span={11} offset={1}>合同金额</Col>
                    <Col span={12}>
                        <Input
                            placeholder='请输入'
                            style={{ width: '100%' }}
                            value={contractNumber}
                            onChange={(e) => setContractNumber(e.target.value)}
                            disabled={loading}
                        />
                    </Col>
                    <Col span={11} offset={1}>
                        <InputNumber
                            style={{ width: '100%' }}
                            formatter={value => `￥ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            min={0}
                            step='0.01'
                            value={contractAmount}
                            onChange={(value) => setContractAmount(value)}
                            disabled={loading}
                        />
                    </Col>
                </Row>
                <Row style={{ marginTop: CNF.rowMarginTop }}>
                    <Col span={24}>备注</Col>
                    <Col span={24}>
                        <TextArea
                            placeholder='备注可写在这里...'
                            rows={2}
                            autoSize={{ minRows: 2, maxRows: 3 }}
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            disabled={loading}
                        />
                    </Col>
                </Row>
            </Modal>
        </>
    );
}

export default Entity